// extracted by mini-css-extract-plugin
module.exports = {"Courses":"Courses_Courses__7tDUY"};